import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Flex.scss';

export function FlexRow({
	as: Component = 'div',
	children,
	className,
	justifyBetween = false,
	justifyEnd = false,
	alignCenter = false,
	alignStart = false,
	alignEnd = false,
	gapSmall = false,
	gapTiny = false,
	...props
}) {
	return (
		<Component
			className={classnames(
				'flex-row',
				{
					'justify-between': justifyBetween,
					'justify-end': justifyEnd,
					'align-center': alignCenter,
					'align-start': alignStart,
					'align-end': alignEnd,
					'gap-small': gapSmall,
					'gap-tiny': gapTiny,
				},
				className,
			)}
			{...props}
		>
			{children}
		</Component>
	);
}

FlexRow.propTypes = {
	as: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
	children: PropTypes.node,
	className: PropTypes.string,
	justifyBetween: PropTypes.bool,
	justifyEnd: PropTypes.bool,
	alignCenter: PropTypes.bool,
	alignStart: PropTypes.bool,
	alignEnd: PropTypes.bool,
	gapSmall: PropTypes.bool,
	gapTiny: PropTypes.bool,
};
